import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {OrganizationSelectors} from '@store/organization/organization.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {LinkButtonComponent} from '@aviary/buttons/link-button/link-button.component';

@Component({
  selector: 'px-mel-link',
  host: {
    class: 'flex flex-row justify-start items-center gap-x-2'
  },
  template: `
    @if (organizationSelectors.usesMEL | select) {
      <p [class]="introCssClasses">{{ introText }}</p>
      <mx-link-button label="Check MeLCat" href="https://elibrary.mel.org/"/>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SelectPipe, LinkButtonComponent]
})
export class MelLinkComponent {

  @Input() public introText: string = '';
  @Input() public introCssClasses: string = 'text-body-large hidden md:block';

  public readonly organizationSelectors = OrganizationSelectors.Auth;
}
